import * as React from 'react';

// material-ui
import Paper from 'material-ui/Paper';

import './TabPanel.css';

export type TabInputProp = {
  readonly title: string
  readonly content: JSX.Element
};

interface Props {
  className?: string;
  tabs: Array<TabInputProp>;
  depth?: number;
}

interface States {
  selectedTab: string;
}

class TabPanel extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedTab: props.tabs[0].title.replace(/\s/g, '')
    };
  }

  render() {
    const {
      className,
      tabs,
      depth
    } = this.props;

    const { selectedTab } = this.state;

    return (
      <Paper zDepth={depth ? depth : 0} className={className}>
        <select
          className="hover-pointer"
          value={selectedTab}
          onChange={this.handleChange}
        >
          {
            tabs.map((tab, index) =>
              <option
                key={index}
                value={tab.title.replace(/\s/g, '')}
              >
                {tab.title}
              </option>
            )
          }
        </select>
        {
          tabs.map((tab, index) => {
            const tabId = tab.title.replace(/\s/g, '');
            return (
              <div
                id={tabId}
                key={index}
                className={(tabId === selectedTab) ? '' : 'd-none'}
                style={{padding: '12pt'}}  
              >
                {tab.content}
              </div>
            );
          })
        }
      </Paper>
    );
  }

  private handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({
      selectedTab: event.target.value
    });
  }
}

export default TabPanel;


// WEBPACK FOOTER //
// ./src/commons/TabPanel.tsx